import Typography from "@mui/material/Typography";
import { useMyOrg } from "@/hooks/use-my-org";
import { useCommercialReadiness } from "./useModuleOffers";
import { CommercialReadinessFacts } from "./ModuleOfferContent";
import {
  ModuleOfferReadError,
  ModuleOfferWorkspace,
} from "./ModuleOfferWorkspace";

export function CommercialReadinessPage() {
  const org = useMyOrg();
  const orgId = org.kind === "error" ? undefined : org.org?.org_id;
  const query = useCommercialReadiness(orgId);
  return (
    <ModuleOfferWorkspace title="Workspace readiness">
      {org.kind === "loading" || (orgId && query.isPending) ? (
        <Typography role="status">Loading readiness…</Typography>
      ) : !orgId || query.isError ? (
        <ModuleOfferReadError onRetry={() => void query.refetch()} />
      ) : query.data && query.data.org_id === orgId ? (
        <CommercialReadinessFacts
          readiness={query.data}
          onRetry={() => void query.refetch()}
        />
      ) : null}
    </ModuleOfferWorkspace>
  );
}
